<script setup>
import { defineProps } from "vue";

const props = defineProps({
    tag: {
        type: String,
        default: "span", // span, h1, h2, h3, h4...
    },
    color: {
        type: String,
        default: "black", // dark, light, primary, secondary, etc.
    },
    weight: {
        type: String,
        default: "regular", // regular | medium | bold
    },
    size: {
        type: String,
        default: null, // pode receber classes como text-h6, sub-title, etc.
    },
});
</script>

<template>
    <component
        :is="tag"
        :class="[
            color ? `text-${color}` : '',
            weight !== 'regular' ? `font-weight-${weight}` : '',
            size ? size : '',
        ]"
    >
        <slot />
    </component>
</template>
